import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BillPayDetailsComponent } from '../../../../pages/reports/report-bills/_components/bill-pay-details/bill-pay-details.component';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { ReportPayTypeEnum } from '../../../enum/reportPayType';
import { Transactions } from '../../../models/transactions';

@Component({
  selector: 'app-report-transactions-table',
  templateUrl: './report-transactions-table.component.html',
  styleUrl: './report-transactions-table.component.scss'
})

export class ReportTransactionsTableComponent {

  @Input() dataSource:Transactions[] = []
  @Input() isPrinting:boolean = false

  reportPayTypeEnum= ReportPayTypeEnum

  constructor(
      private modalService:NgbModal,
      private translateService:TranslateService,
    ) {
    }

      /*------------------------ Show more bill reference dialog ------------------------ */
  showMore(ref:any) {
    Swal.fire({
      title: ref,
      // showCloseButton: true,
      confirmButtonText: this.translateService.instant('Common.Discard')
    });
  }
  showTransactionPayDetails(transaction:any){
    let modalRef = this.modalService.open(BillPayDetailsComponent, { centered: true , size: 'md'});
    modalRef.componentInstance.bill = transaction;
    modalRef.componentInstance.isTransactionView = true;
  }
}
